<template>
  <div class="app-shell-quiz">
    <!-- Hidden Fields (SID, AID, app_source, etc) -->
    <AppHiddenFields />

    <!-- Router View -->
    <AppRouterViewContainer>
      <transition
        :name="transitionName"
        mode="out-in"
        @after-enter="$_stickyCTA_afterEnter"
        @before-leave="$_stickyCTA_beforeLeave"
      >
        <router-view :theme="theme" />
      </transition>
    </AppRouterViewContainer>
    <!-- App Footer -->
    <AppSimpleFooter />
  </div>
</template>

<script>
import AppSimpleFooter from '@/components/layout/AppSimpleFooter'
import AppHiddenFields from '@/components/common/fields/AppHiddenFields'
import transitions from '@/mixins/transitions'
import AppRouterViewContainer from '@/components/common/AppRouterViewContainer'
import stickyCTA from '@/mixins/sticky-cta'
import theme from '@/mixins/theme'
import tracking from '@/mixins/tracking'

export default {
  // Name
  name: 'AppShellFooterOnly',

  // Components
  components: {
    AppSimpleFooter,
    AppHiddenFields,
    AppRouterViewContainer
  },

  // Mixins
  mixins: [
    transitions,
    stickyCTA,
    theme,
    tracking
  ],

  props: {
    module: {
      type: String,
      default: undefined
    },
    canonicalModule: {
      type: String,
      default: ''
    }
  },

  head () {
    return {
      link: [
        { rel: 'canonical', href: this.$_tracking_canonicalURL(this.canonicalModule || this.module) }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/step-transitions';

.app-shell-quiz {
  @apply overflow-x-hidden pt-70 flex flex-col min-h-[100vh];
}
</style>
